import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const cleaningServices = [
  {
    id: "residential-cleaning",
    img: "https://readdy.ai/api/search-image?query=beautiful%20slim%20young%20woman%20professional%20cleaner%20green%20uniform%20smiling%20confidently%20vacuuming%20bright%20modern%20living%20room%20Florida%20home%20sparkling%20clean%20warm%20natural%20light&width=800&height=520&seq=home_res_w1&orientation=landscape",
    icon: "ri-home-smile-line",
    enTitle: "Residential Cleaning",
    esTitle: "Limpieza Residencial",
    enDesc: "Regular maintenance cleaning to keep your home fresh and spotless every week.",
    esDesc: "Limpieza de mantenimiento regular para mantener tu hogar fresco e impecable cada semana.",
  },
  {
    id: "deep-cleaning",
    img: "https://readdy.ai/api/search-image?query=handsome%20young%20man%20professional%20cleaner%20uniform%20scrubbing%20kitchen%20countertops%20deep%20cleaning%20gleaming%20surfaces%20bright%20modern%20Florida%20home%20focused%20natural%20light&width=800&height=520&seq=home_deep_m1&orientation=landscape",
    icon: "ri-sparkling-2-line",
    enTitle: "Deep Cleaning",
    esTitle: "Limpieza Profunda",
    enDesc: "Thorough top-to-bottom cleaning reaching every corner, ideal for seasonal resets.",
    esDesc: "Limpieza exhaustiva de arriba a abajo llegando a cada rincón, ideal para reinicios de temporada.",
  },
  {
    id: "move-in-cleaning",
    img: "https://readdy.ai/api/search-image?query=beautiful%20slim%20young%20woman%20professional%20cleaner%20uniform%20mopping%20gleaming%20floors%20empty%20bright%20new%20apartment%20move%20in%20cleaning%20Florida%20cheerful%20smile%20natural%20light%20warm&width=800&height=520&seq=home_movein_w1&orientation=landscape",
    icon: "ri-door-open-line",
    enTitle: "Move-in Cleaning",
    esTitle: "Limpieza de Entrada",
    enDesc: "Start fresh in your new home — we make it spotless before you move in.",
    esDesc: "Empieza de cero en tu nuevo hogar — lo dejamos impecable antes de que te mudes.",
  },
  {
    id: "move-out-cleaning",
    img: "https://readdy.ai/api/search-image?query=professional%20man%20cleaner%20uniform%20wiping%20cleaning%20empty%20apartment%20move%20out%20spotless%20bright%20Florida%20home%20natural%20light%20hardworking%20focused%20professional%20service&width=800&height=520&seq=home_moveout_m1&orientation=landscape",
    icon: "ri-logout-box-r-line",
    enTitle: "Move-out Cleaning",
    esTitle: "Limpieza de Salida",
    enDesc: "Get your full deposit back — we clean every inch to meet landlord standards.",
    esDesc: "Recupera tu depósito completo — limpiamos cada centímetro según los estándares del arrendador.",
  },
  {
    id: "airbnb-cleaning",
    img: "https://readdy.ai/api/search-image?query=beautiful%20slim%20young%20woman%20professional%20cleaner%20uniform%20making%20bed%20hotel%20style%20white%20linens%20bright%20modern%20bedroom%20Airbnb%20vacation%20rental%20Florida%20smiling%20warm%20natural%20light&width=800&height=520&seq=home_airbnb_w1&orientation=landscape",
    icon: "ri-building-4-line",
    enTitle: "Airbnb Cleaning",
    esTitle: "Limpieza Airbnb",
    enDesc: "Fast turnovers between guests — hotel-quality results to boost your ratings.",
    esDesc: "Cambios rápidos entre huéspedes — resultados de calidad hotelera para mejorar tus calificaciones.",
  },
];

const handymanCategories = [
  {
    labelEn: "Basic Home Repairs",
    labelEs: "Reparaciones Básicas",
    icon: "ri-home-gear-line",
    items: [
      { id: "door-repairs", icon: "ri-door-line", enTitle: "Door Repairs", esTitle: "Reparación de Puertas" },
      { id: "cabinet-fixes", icon: "ri-archive-line", enTitle: "Cabinet & Drawer Fixes", esTitle: "Gabinetes y Cajones" },
      { id: "baseboard-trim", icon: "ri-layout-bottom-line", enTitle: "Baseboards & Trim", esTitle: "Zócalos y Molduras" },
    ],
  },
  {
    labelEn: "Painting & Touch-Ups",
    labelEs: "Pintura y Retoques",
    icon: "ri-paint-brush-line",
    items: [
      { id: "interior-painting", icon: "ri-paint-brush-line", enTitle: "Interior Painting", esTitle: "Pintura Interior" },
      { id: "patch-paint", icon: "ri-brush-line", enTitle: "Patch & Paint Walls", esTitle: "Parchar y Pintar" },
      { id: "tenant-touchups", icon: "ri-edit-box-line", enTitle: "Touch-ups (Tenants)", esTitle: "Retoques entre Inquilinos" },
    ],
  },
  {
    labelEn: "Installation Services",
    labelEs: "Instalaciones",
    icon: "ri-tv-line",
    items: [
      { id: "tv-mounting", icon: "ri-tv-line", enTitle: "TV Mounting", esTitle: "Instalación de TV" },
      { id: "curtain-rods-blinds", icon: "ri-layout-top-line", enTitle: "Curtain Rods & Blinds", esTitle: "Cortinas y Persianas" },
      { id: "shelves-wall-decor", icon: "ri-layout-grid-line", enTitle: "Shelves & Wall Decor", esTitle: "Estantes y Decoración" },
      { id: "furniture-assembly", icon: "ri-sofa-line", enTitle: "Furniture Assembly", esTitle: "Ensamblaje de Muebles" },
    ],
  },
  {
    labelEn: "Exterior & Maintenance",
    labelEs: "Exterior y Mantenimiento",
    icon: "ri-leaf-line",
    items: [
      { id: "pressure-washing", icon: "ri-drop-line", enTitle: "Pressure Washing", esTitle: "Lavado a Presión" },
      { id: "gutter-cleaning", icon: "ri-water-flash-line", enTitle: "Gutter Cleaning", esTitle: "Limpieza de Canaletas" },
      { id: "fence-repairs", icon: "ri-layout-grid-line", enTitle: "Fence Repairs", esTitle: "Reparación de Cercas" },
      { id: "landscaping", icon: "ri-plant-line", enTitle: "Small Landscaping", esTitle: "Jardinería Pequeña" },
    ],
  },
];

const ServicesPreview = () => {
  const { i18n } = useTranslation();
  const isEs = i18n.language === "es";

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <span className="inline-block text-brand-green font-body text-sm font-semibold tracking-widest uppercase mb-2">
              {isEs ? "Lo Que Ofrecemos" : "What We Offer"}
            </span>
            <h2 className="font-heading font-black text-brand-dark text-3xl md:text-4xl lg:text-5xl leading-tight">
              {isEs ? "Servicios de" : "Professional"}<br />
              <span className="text-brand-green">{isEs ? "Limpieza Profesional" : "Cleaning Services"}</span>
            </h2>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 border border-brand-dark/20 hover:border-brand-green hover:text-brand-green text-brand-dark px-5 py-2.5 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            {isEs ? "Ver Todos" : "View All Services"}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Cleaning Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
          {cleaningServices.slice(0, 3).map((svc) => (
            <Link
              key={svc.id}
              to={`/services/${svc.id}`}
              className="relative overflow-hidden rounded-2xl group cursor-pointer"
            >
              <div className="relative h-72">
                <img
                  src={svc.img}
                  alt=""
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
                <div className="absolute inset-0 p-5 flex flex-col justify-end">
                  <div className="w-9 h-9 flex items-center justify-center bg-brand-green rounded-xl mb-2">
                    <i className={`${svc.icon} text-white text-base`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-white text-base mb-1">
                    {isEs ? svc.esTitle : svc.enTitle}
                  </h3>
                  <p className="font-body text-white/65 text-xs leading-relaxed line-clamp-2 mb-2">
                    {isEs ? svc.esDesc : svc.enDesc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-brand-green font-heading font-semibold text-xs group-hover:gap-2 transition-all">
                    {isEs ? "Ver Servicio" : "View Service"} <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-6">
          {cleaningServices.slice(3, 5).map((svc) => (
            <Link
              key={svc.id}
              to={`/services/${svc.id}`}
              className="relative overflow-hidden rounded-2xl group cursor-pointer"
            >
              <div className="relative h-72">
                <img
                  src={svc.img}
                  alt=""
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
                <div className="absolute inset-0 p-5 flex flex-col justify-end">
                  <div className="w-9 h-9 flex items-center justify-center bg-brand-green rounded-xl mb-2">
                    <i className={`${svc.icon} text-white text-base`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-white text-base mb-1">
                    {isEs ? svc.esTitle : svc.enTitle}
                  </h3>
                  <p className="font-body text-white/65 text-xs leading-relaxed line-clamp-2 mb-2">
                    {isEs ? svc.esDesc : svc.enDesc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-brand-green font-heading font-semibold text-xs group-hover:gap-2 transition-all">
                    {isEs ? "Ver Servicio" : "View Service"} <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 my-14">
          <div className="flex-1 h-px bg-gray-100"></div>
          <span className="font-heading font-bold text-brand-dark text-sm tracking-widest uppercase px-4">
            {isEs ? "También Ofrecemos" : "Also Available"}
          </span>
          <div className="flex-1 h-px bg-gray-100"></div>
        </div>

        {/* Handyman Section */}
        <div className="flex flex-col md:flex-row gap-10 items-start">
          {/* Left: Image */}
          <div className="w-full md:w-2/5 relative rounded-2xl overflow-hidden flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20handyman%20man%20woman%20team%20working%20home%20repairs%20painting%20installation%20tools%20Florida%20residential%20bright%20interior%20natural%20light%20confident%20skilled&width=700&height=500&seq=handyman_team1&orientation=landscape"
              alt="Handyman Services"
              className="w-full h-72 md:h-80 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/60 to-transparent"></div>
            <div className="absolute bottom-5 left-5">
              <span className="font-heading font-black text-white text-2xl leading-tight block">
                {isEs ? "Servicios de\nReparación" : "Handyman\nServices"}
              </span>
            </div>
          </div>

          {/* Right: Subcategories */}
          <div className="w-full md:w-3/5">
            <p className="font-body text-gray-500 text-sm mb-6 leading-relaxed">
              {isEs
                ? "Reparaciones confiables, instalaciones y mantenimiento para cada rincón de tu hogar. Un solo equipo para todas tus necesidades."
                : "Reliable repairs, installations, and maintenance for every corner of your home. One team for all your needs."}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {handymanCategories.map((cat) => (
                <div key={cat.labelEn}>
                  <div className="flex items-center gap-2 mb-2">
                    <i className={`${cat.icon} text-brand-navy text-sm`}></i>
                    <span className="font-heading font-bold text-brand-dark text-xs uppercase tracking-wide">
                      {isEs ? cat.labelEs : cat.labelEn}
                    </span>
                  </div>
                  <div className="flex flex-col gap-1">
                    {cat.items.map((item) => (
                      <Link
                        key={item.id}
                        to={`/services/${item.id}`}
                        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-50 hover:bg-brand-navy/5 border border-gray-100 hover:border-brand-navy/20 transition-all cursor-pointer group"
                      >
                        <div className="w-6 h-6 flex items-center justify-center">
                          <i className={`${item.icon} text-brand-dark group-hover:text-brand-navy text-sm transition-colors`}></i>
                        </div>
                        <span className="font-body text-brand-dark text-xs leading-tight">
                          {isEs ? item.esTitle : item.enTitle}
                        </span>
                        <i className="ri-arrow-right-s-line text-gray-300 group-hover:text-brand-navy ml-auto text-xs transition-colors"></i>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 mt-6 text-brand-navy font-heading font-semibold text-sm hover:gap-3 transition-all cursor-pointer"
            >
              {isEs ? "Ver todos los servicios" : "View all services"}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Odd Jobs Banner */}
        <div className="mt-14 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-100 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-xl flex-shrink-0">
              <i className="ri-hammer-line text-white text-xl"></i>
            </div>
            <div>
              <h3 className="font-heading font-bold text-brand-dark text-base">
                {isEs ? "Trabajos Varios" : "Odd Jobs"}
              </h3>
              <p className="font-body text-gray-500 text-sm">
                {isEs
                  ? "Limpieza puntual, Airbnb y reparaciones pequeñas — sin compromiso."
                  : "One-time cleaning, Airbnb, and small repairs — no commitment needed."}
              </p>
            </div>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white px-5 py-2.5 rounded-full font-heading font-semibold text-sm transition-all cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            {isEs ? "Ver Trabajos Varios" : "View Odd Jobs"}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
